import CharacterCount from '@tiptap/extension-character-count'

import { EDITOR_CONTENT_LENGTH_DEFAULTS } from './constants'

export type CharacterCountError = 'required' | 'too_short' | 'too_long' | null

export interface CharacterCountValidationOptions {
  minLength: number
  maxLength: number
  required: boolean
}

export interface CharacterCountStorageWithValidation {
  characters: (options?: { mode?: string; node?: unknown }) => number
  error: CharacterCountError
  words: (options?: { node?: unknown }) => number
}

declare module '@tiptap/core' {
  interface CharacterCountStorage extends CharacterCountStorageWithValidation {}
}

export function computeCharacterCountError(
  count: number,
  options: CharacterCountValidationOptions,
): CharacterCountError {
  if (options.required && count === 0) {
    return 'required'
  }

  if (count < options.minLength) {
    return 'too_short'
  }

  if (count > options.maxLength) {
    return 'too_long'
  }

  return null
}

export const CharacterCountWithValidation = CharacterCount.extend<
  CharacterCountValidationOptions,
  CharacterCountStorageWithValidation
>({
  addOptions() {
    return {
      ...this.parent?.(),
      minLength: EDITOR_CONTENT_LENGTH_DEFAULTS.MIN,
      maxLength: EDITOR_CONTENT_LENGTH_DEFAULTS.MAX,
      required: false,
    }
  },

  addStorage() {
    return {
      ...this.parent?.(),
      error: null as CharacterCountError,
    }
  },

  onUpdate() {
    const count = this.storage.characters?.() ?? 0

    this.storage.error = computeCharacterCountError(count, {
      minLength: this.options.minLength,
      maxLength: this.options.maxLength,
      required: this.options.required,
    })
  },
})
